import { Calendar} from '@fullcalendar/core';
import monthGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";

$(() => {
    function filter (events) {
    }
    var businessHoursCalendarEl = document.getElementById('business_hours_calendar');
    // 翌月以降が公開中かどうか
    var multiMonth = businessHoursCalendarEl.dataset.multiMonth;
    // 動的にツールバーの表示を変化
    var headerToolbarLeft = multiMonth == "true" ? "prev next" : "title";
    var headerToolbarCenter = multiMonth == "true" ? "title" : false;
    // 最終日
    var lastEventDate = '';
    var dayCellClassNamesStatus
    if ($('.disable_flg').val() == 1){
      dayCellClassNamesStatus = 'disable-business-day'
    } else {
      dayCellClassNamesStatus = 'not-business-day'
    }
    let firstDayForCalendar = $('.first-day-for-calendar').val();
    let lastBusinessDay = $('.last-business-day').val();

    var calendar = new Calendar(businessHoursCalendarEl, {
      plugins: [monthGridPlugin, interactionPlugin],
      eventSources: [
        {
          url: location.pathname + ".json",
        },
      ],
      dayCellClassNames: dayCellClassNamesStatus,
      dayCellContent: function(e) {
        e.dayNumberText = e.dayNumberText.replace("日", "");
      },
      eventDidMount: function(event, element) {
        if (event) {
          $(event.el.closest(".fc-daygrid-day")).removeClass("not-business-day");
          if (event.event.id == "store_holiday") {
            $(event.el.closest(".fc-daygrid-day")).addClass("store-holiday");
          }
        }
      },
      // カレンダーの範囲を動的に決める
      validRange: function(nowDate) {
        return {
          start: $('.first-business-day').val(),
          end: $('.calendar-container').data('end'),
        };
      },
      locale: "ja",
      timeZone: "Asia/Tokyo",
      showNonCurrentDates: true,
      fixedWeekCount: true,
      headerToolbar: {
        left: headerToolbarLeft,
        start: false,
        center: headerToolbarCenter,
        right: false,
      },
      expandRows: true,
      stickyHeaderDates: true,
      height: 205,
      contentHeight: "auto",
      datesSet: function(dateInfo) {
        if (new Date(dateInfo.view.currentStart) <= new Date()) {
          $('.fc-prev-button').prop('disabled', true);
        } else {
          $('.fc-prev-button').prop('disabled', false);
        }
        if (new Date(lastBusinessDay) <= new Date(dateInfo.endStr)) {
          $('.fc-next-button').prop('disabled', true);
        } else {
          $('.fc-next-button').prop('disabled', false);
        }
      },
    });
    calendar.render();
});

$(function(){
  var headerToolBarRight = $('.fc-header-toolbar .fc-toolbar-chunk:last');
  headerToolBarRight.append('<p class="tenkyubi"><span style="color: #ffbaba">&#9632;</span>＝店休日</p>');
})
